import { Route } from '@angular/router';
import { subscriptionAccessGuard } from '@rma/billing/subscription-plans/public/api-subscription-features';

export const socialMediaRoutes: Route[] = [
  {
    path: '',
    loadChildren: () => import('@rma/social-media-manager/manage-shell'),
  },
  {
    path: 'post',
    loadChildren: () => import('@rma/social-media-manager/share'),
    canActivate: [subscriptionAccessGuard('HasSocialMedia', '/socialmedia/about')],
  },
  // Legacy SMM manual post redirects.
  {
    path: 'share',
    loadChildren: () => import('@rma/social-media-manager/share').then((m) => m.legacySocialMediaShareRoutes),
  },
];
